/**
 * 2007-2019 PrestaShop and Contributors
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to https://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2019 PrestaShop SA and Contributors
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import 'expose-loader?Tether!tether';
import 'bootstrap/dist/js/bootstrap.min';
import 'flexibility';
import 'bootstrap-touchspin';

import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';

import DropDown from './components/drop-down';
import Form from './components/form';
import ProductMinitature from './components/product-miniature';
import ProductSelect from './components/product-select';
import TopMenu from './components/top-menu';

import prestashop from 'prestashop';
import EventEmitter from 'events';

import './lib/bootstrap-filestyle.min';
import './lib/jquery.scrollbox.min';
import './lib/modernizr-custom.js';
import './lib/slick';

import './components/block-cart';

// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
    prestashop[i] = EventEmitter.prototype[i];
}

$(document).ready(() => {
    let dropDownEl = $('.js-dropdown');
    const form = new Form();
    let topMenuEl = $('.js-top-menu ul[data-depth="0"]');
    let dropDown = new DropDown(dropDownEl);
    let topMenu = new TopMenu(topMenuEl);
    let productMinitature = new ProductMinitature();
    let productSelect  = new ProductSelect();
    dropDown.init();
    form.init();
    topMenu.init();
    productMinitature.init();
    productSelect.init();

    let $htmlBody = $('html, body');
    let $html = $('html');
    let $body = $('body');
    let $header = $('.header');
    if($header.length){
        var scrollTopHeaderFunction = function (event) {
            var scrollTop = $(window).scrollTop();
            if(scrollTop > 100){
                $body.addClass('scrolled');
            } else {
                $body.removeClass('scrolled');
            }
        };
        window.addEventListener('scroll', scrollTopHeaderFunction, false);
        scrollTopHeaderFunction();
    }

    let $sliderProducts = $('.featured-products .products');
    if($sliderProducts.length){
        $sliderProducts.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 3000,
            centerMode: false,
            centerPadding: 0,
            focusOnSelect: false,
            dots: false,
            prevArrow: '<button type="button" data-role="none" class="products--arrow products--arrow--prev" aria-label="Précédent" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="26.651" height="45.795" viewBox="0 0 26.651 45.795"><path fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="4" d="M25.267 44.351L2.89 22.897 25.267 1.443"/></svg></button>',
            nextArrow: '<button type="button" data-role="none" class="products--arrow products--arrow--next" aria-label="Suivant" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="26.651" height="45.795" viewBox="0 0 26.651 45.795"><path fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="4" d="M1.384 44.351l22.377-21.454L1.384 1.443"/></svg></button>',
            arrows: true,
            infinite: false,
            speed: 600,
            fade: false,
            cssEase: 'linear',
            responsive: [
                {
                    breakpoint: 1025,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

    let $relatedProducts = $('.product-accessories .products');
    if($relatedProducts.length){
        $relatedProducts.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 3000,
            centerMode: false,
            centerPadding: 0,
            focusOnSelect: false,
            dots: false,
            prevArrow: '<button type="button" data-role="none" class="products--arrow products--arrow--prev" aria-label="Précédent" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="26.651" height="45.795" viewBox="0 0 26.651 45.795"><path fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="4" d="M25.267 44.351L2.89 22.897 25.267 1.443"/></svg></button>',
            nextArrow: '<button type="button" data-role="none" class="products--arrow products--arrow--next" aria-label="Suivant" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="26.651" height="45.795" viewBox="0 0 26.651 45.795"><path fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="4" d="M1.384 44.351l22.377-21.454L1.384 1.443"/></svg></button>',
            arrows: true,
            infinite: false,
            speed: 600,
            fade: false,
            cssEase: 'linear',
            responsive: [
                {
                    breakpoint: 1025,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

    let $cmspSliderItems = $('.cmsp--slider--items');
    if($cmspSliderItems.length){
        $cmspSliderItems.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            centerMode: false,
            centerPadding: 0,
            focusOnSelect: true,
            dots: true,
            dotsClass: 'cmsp--slider--dots',
            prevArrow: '<button type="button" data-role="none" class="cmsp--slider--arrow cmsp--slider--arrow--prev" aria-label="Précédent" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="26.651" height="45.795" viewBox="0 0 26.651 45.795"><path fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="4" d="M25.267 44.351L2.89 22.897 25.267 1.443"/></svg></button>',
            nextArrow: '<button type="button" data-role="none" class="cmsp--slider--arrow cmsp--slider--arrow--next" aria-label="Suivant" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="26.651" height="45.795" viewBox="0 0 26.651 45.795"><path fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="4" d="M1.384 44.351l22.377-21.454L1.384 1.443"/></svg></button>',
            arrows: true,
            infinite: true,
            speed: 600,
            fade: true,
            cssEase: 'linear',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        dots: false
                    }
                }
            ]
        });
    }

    let $headerTriggerButton = $('.header--trigger--button');
    if($headerTriggerButton.length){
        $headerTriggerButton.on('click', function(){
            if($body.hasClass('has-menu-open')){
                $body.removeClass('has-menu-open')
            } else {
                $body.addClass('has-menu-open')
            }
        });
    }

    let $cartItems = $('.cart-items');
    if ($cartItems.length) {
        let $id_category = $('.featured-suggestions').attr('data-id-category');
        let $bool = false;
        let $action = $('.cart-detailed-actions');
        $action.on('click', function() {
            // on enregistre le message et le papier cadeau dans le panier
            let $formCart = $('.cart-options');
            let $action_url = $formCart.attr('data-action');
            let $data = $formCart.serialize();
            $.post({
                url: $action_url,
                data: $data,
                success: function (response) {
                }
            });
            // On vérifie si le panier contient un produit de la catégorie "Contenant"
            $('.cart-item').each(function () {
                let $id_category_product = $('.remove-from-cart', $(this)).attr('data-id-category');
                if ($id_category_product == $id_category) {
                    $bool = true;
                }
            });
            if ($bool) {
                let $href = $('.btn', $action).attr('data-href');
                $('.btn', $action).attr('href', $href);
            } else {
                // on affiche une modale
                $('#cart-modal').modal('show');
            }
        })
    }

    let $giftOptions = $('.cart-gift--option');
    if ($giftOptions.length) {
        $('.custom-checkbox', $giftOptions).on('click', function() {
            let $value = $('input[type="checkbox"]', $(this)).attr('value');
            if ($value == 1) {
                $('input[value="2"]', $giftOptions).prop({
                    checked: false
                });
            } else if ($value == 2) {
                $('input[value="1"]', $giftOptions).prop({
                    checked: false
                });
            }
        })
    }

    let $orderOptions = $('.order-options');
    if ($orderOptions.length) {
        $('.custom-checkbox', $orderOptions).on('click', function() {
            let $name = $('input[type="radio"]', $(this)).attr('name');
            if ($name == 'recyclable') {
                $('input[name="gift"]', $orderOptions).prop({
                    checked: false
                });
            } else if ($name == 'gift') {
                $('input[name="recyclable"]', $orderOptions).prop({
                    checked: false
                });
            }
        })
    }

    let $categories = $('.block-categories');
    if ($categories.length) {
        if ($('.category-sub-menu li.active', $categories).length) {
            let $div = $('.category-sub-menu li.active', $categories).closest('div');
            $div.collapse();
        }
    }

    // let hash = window.location.hash;
    // if(hash){
    //     let $target = $(hash);
    //     if($target.length){
    //         let offset = $target.offset().top;
    //         $htmlBody.animate({scrollTop: offset}, 600);
    //     }
    // }

});

// function bumpMove(e) {
//     TweenMax.to('#headerBump path', 2.8, {
//         //scaleY: .7,
//         scaleX: 1,
//         svgOrigin: "200 0",
//         transformOrigin: "50% top",
//         ease: Back.easeOut
//     });
//     TweenMax.to('#headerBump path', 2.8, {
//         scaleX: 1,
//         svgOrigin: "200 0",
//         transformOrigin: "50% top"
//     });
//     TweenMax.to('#headerBump', .8, {
//         left: e.pageX,
//         ease: Back.easeOut
//     });
// }
// function bumpMoveBack() {
//     TweenMax.to('#headerBump path', 1.8, {
//         scaleY: 1,
//         svgOrigin: "200 0",
//         transformOrigin: "50% top",
//         ease: Elastic.easeOut.config(.9, 0.2)
//     });
//     TweenMax.to('#headerBump path', .8, {
//         scaleX: 1,
//         svgOrigin: "200 0",
//         transformOrigin: "50% top"
//     });
//     TweenMax.to('#headerBump', .8, {
//         left: window.innerWidth / 2,
//         ease: Back.easeOut
//     });
// }
// window.onresize = function(event) {
//     bumpMoveBack();
// };
// var headerTop = document.querySelector('.header--top');
// if (headerTop){
//     headerTop.onmousemove = function(e) {
//         bumpMove(e);
//     };
//     headerTop.onmouseleave = function() {
//         bumpMoveBack();
//     };
// }



// WEBPACK FOOTER //
// ./js/theme.js